import React from "react";
import "./LandDetail.scss";

import { Icon } from "@iconify/react";
import ListedCard from "../landListedCard/ListedCard";
import Chart from "react-apexcharts";

function LandDetail() {
  const options = {
    xaxis: {
      categories: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    },
    colors: ["#D501FA", "#ffffff", "#ffffff"], // Specify colors for each series
    chart: {
      toolbar: {
        show: false, // Hide the toolbar (including zoom icons and other controls)
      },
    },
    zoom: {
      enabled: false, // Disable zoom functionality
    },
  };
  const series = [
    {
      name: "s1",
      data: [30, 40],
    },
  ];
  return (
    <div>
      <div className="pioneer-land">
        <div className="pioneer-land-content">
          <button className="back ">
            <Icon
              icon="ion:chevron-back"
              color="white"
              width="30"
              height="25"
            />
            BACK
          </button>
          <div className="pioneer-land-lower">
            <div className="pioneer-land-left">
              <div className="card-header">
                <img
                  src="\assets\images\RecentListingImages\PlayerPlot.png"
                  alt="Pioneer-Land"
                  className="img-100"
                />
              </div>
            </div>
            <div className="pioneer-land-right flex-column ">
              <div className="d-flex some-right">
                <div className="right-1">
                  <h1>Pioneer Land</h1>
                  <h4>
                    Owned by <span className="text-primary">Astrality</span>
                    <img
                      className="mx-4 logo"
                      src="\assets\images\PioneerLandICon.svg"
                      alt="PioneerLandIcon"
                    />
                  </h4>
                  <p>
                    <img src="\assets\images\PioneerLandEye.svg" alt="" />
                    <span className="mx-2">5412 Views</span>
                  </p>
                  <h4>Highest Rent Offer</h4>
                  <p>$ 1.542</p>
                  <h4>
                    Rent Demand
                    <img
                      className="mx-3"
                      src="\assets\images\PioneerLandHigh.svg"
                      alt="PioneerLandHigh"
                    />
                    High
                  </h4>
                  <button>BUY NOW</button>
                </div>
                <div className="right-2">
                  <h4>Location</h4>
                  <p>Astra City</p>
                  <h4>Land Type</h4>
                  <p>Pioneer Land</p>
                  <h4>Coordinates</h4>
                  <p className="text-light-green">13.25.42</p>
                </div>
              </div>
              <div className="description ">
                <h4>Description</h4>
                <p>
                  Astra City is the urban hub of the heartbeat of Astrality.
                  Skyscrapers filled with virtual offices, buzzing digital
                  marketplaces, and lively social spaces make it a hotspot for
                  businesses and social butterflies alike. The city is the
                  fusion of modern and futuristic architecture, embodying the
                  spirit of progress and innovation that Astrality stands for.
                </p>
              </div>
            </div>
          </div>
          <div className="rental-demand">
            <div className="rental-demand-heading">
              <h1>Rental Demand</h1>
            </div>
            <div className="rental-demand-para">
              <p>
                <b className="text-white">854</b> requests to Rent the Land at{" "}
                <b className="text-white">USDT 521</b> or Lower
              </p>
            </div>
          </div>
          <div className="perk-content">
            <div className="perk-head">
              <h1>Perks</h1>
            </div>
            <div className="perk-body">
              <p>Revealing soon</p>
            </div>
          </div>
          <div className="perk-content">
            <div className="perk-head">
              <h1>Utilities</h1>
            </div>
            <div className="perk-body">
              <p>Revealing soon</p>
            </div>
          </div>
          <div className="perk-content">
            <div className="perk-head">
              <h1>Land Activity</h1>
            </div>
            <div className="perk-body">
              <div className="graph-parent w-100">
                <div className="rentel-graph w-100">
                  <Chart
                    options={options}
                    series={series}
                    width="75%"
                    height="242px"
                    type="area"
                    className="d-flex justify-content-center"
                  />
                  <p className="text-center">
                    <span className="one text-light-grey">Price</span>
                    <span className="two ">
                      Highest: $2,583 <span className="first">Lowest: $83</span>
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="collection">
            <div className="collection-content">
              <h1>More Land From This Collection</h1>
            </div>
          </div>
          {/*Card  */}
          <ListedCard />
        </div>
      </div>
    </div>
  );
}

export default LandDetail;
